// src/apiConfig.js
//
// WHAT THIS FILE IS:
// A single, shared source of truth for the backend API's base URL.
// Every Form and Page component imports API_BASE_URL from here instead
// of hardcoding 'http://127.0.0.1:8000' directly - so if the API
// address ever changes again (new domain, different port, etc.), we
// only need to update this ONE file instead of hunting through 13
// separate files.
//
// HOW IT WORKS:
// process.env.REACT_APP_API_URL reads an environment variable that
// gets baked in at BUILD TIME (when you run `npm run build`) - not at
// runtime like Django's os.environ. Create React App only exposes
// environment variables to your code if their name starts with
// REACT_APP_ - this is a security measure, so you don't accidentally
// expose unrelated system environment variables to the browser.
//
// The fallback ('http://127.0.0.1:8000') keeps local development
// working exactly as before, with zero extra setup - `npm start`
// doesn't set this environment variable, so it just uses your familiar
// local Django address.

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
